import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import Typography from '../typography/Typography';
import { StepIndex, StepWrapper } from './styles';
export const ReferralProgramStep = ({ desc, index, className, descFont, descColor, indexType, indexSize, }) => {
    const { colors } = useTheme();
    return (_jsxs(StepWrapper, { className: className, children: [_jsx(StepIndex, { className: "stepIndex", children: _jsx(Typography, { type: indexType || 'headline', color: colors.text.interactive, fontFamily: indexSize, children: index }) }), _jsx(Typography, { type: "subHeadline", color: descColor || colors.text.secondary, fontFamily: descFont, children: desc })] }));
};
export default ReferralProgramStep;
//# sourceMappingURL=ReferralProgramStep.js.map